import type { QueryClient } from '@tanstack/react-query'

/**
 * Both wizards read their field metadata from REFERENCE-profile queries - a
 * 60-min TTL persisted to IndexedDB - so a config edit stays invisible to them,
 * across reloads, until the TTL lapses. Every write that changes a schema or
 * template shape has to drop them, the same way `entity-type` and
 * `material-pricing-facets` are dropped by their editors.
 */

/** Create-claim wizard metadata: attributes, their SELECT options, workflow. */
export function invalidateClaimWizardMetadata(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['create-claim-metadata'] })
}

/** Registration wizard metadata: product/host/transaction form schema. */
export function invalidateRegistrationWizardMetadata(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['holding-form-schema'] })
}
